import { render, staticRenderFns } from "./StandartsCatalogClinRecPage.vue?vue&type=template&id=3706c722&"
import script from "./StandartsCatalogClinRecPage.vue?vue&type=script&lang=js&"
export * from "./StandartsCatalogClinRecPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports